import { makeStyles } from '@material-ui/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: '500',
  },
}));

function TextToInput({ uiText, disabled, onValueChange }) {
  const classes = useStyles();

  const [showInput, setShowInput] = useState(false);
  const [currentTextData, setCurrentTextdata] = useState('');
  const inputRef = useRef('');

  // Updates the local state with every new prop.
  useEffect(() => {
    setCurrentTextdata(uiText);
  }, [uiText]);

  const handleOnBlur = useCallback(() => {
    const inputEntry = inputRef.current.value.trim();
    if (inputEntry) {
      if (typeof onValueChange === 'function') {
        onValueChange({
          prevValue: currentTextData,
          currentValue: inputEntry,
          valueChanged: currentTextData !== inputEntry,
        });
      }
      setCurrentTextdata(inputRef.current.value);
    }
    setShowInput(false);
    // eslint-disable-next-line
  }, [showInput]);

  const getTextElement = () => (
    <div className={classes.title} onDoubleClick={() => (!disabled ? setShowInput(true) : null)}>
      {currentTextData}
    </div>
  );

  const getInputElement = () => (
    <input
      defaultValue={currentTextData}
      onBlur={handleOnBlur}
      ref={inputRef}
      maxLength={200}
      required
      autoFocus
    />
  );

  return <>{showInput ? getInputElement() : getTextElement()}</>;
}

export const TextToInputComponent = React.memo(TextToInput);
